import { ComumApi } from "./ComumApi";
import { OrcamentoApi } from "./OrcamentoApi";
import { ParametroApi } from "./ParametroApi";
import { ProdutoApi } from "./ProdutoApi";
import { TipoPesquisaApi } from "./TipoPesquisaApi";
import { SegurancaApi } from "./SegurancaApi";
import { PermissaoFuncionalidadeApi } from "./PermissaoFuncionalidadeApi";
import { FilialApi } from "./FilialApi";
import { VendedorApi } from "./VendedorApi";
import { UsuarioApi } from "./UsuarioApi";
import { FornecedorApi } from "./ForncedorApi";
import { FreteApi } from "./FreteApi";
import { CupomDescontoApi } from "./CupomDescontoApi";
import { ClienteApi } from "./ClienteApi";
import { PessoaApi } from "./PessoaApi";
import { AgenteDiaUtilApi } from "./AgenteDiaUtilApi";
import { ObraApi } from "./ObraAPI";
import { CotacaoPerdidaApi } from "./CotacaoPerdidaApi";
import { AtendimentoClienteApi } from "./AtendimentoClienteApi";
import { LoginApi } from "./LoginApi";
import { LicenciamentoApi } from "./LicenciamentoApi";
import { UnificacaoDeOrcamentosApi } from "./UnificacaoDeOrcamentosApi";
import { NotaFiscalSaidaApi } from "./NotaFiscalSaidaApi";
import { ConhecimentoTransportelApi } from "./ConhecimentoTransporteApi";
import { NotaFiscalEntradaApi } from "./NotaFiscalEntradaApi";
import { OrdemProducaoApi } from "./OrdemProducaoApi";
import { DesdobramentoApi } from "./DesdobramentoApi";
import { WhatsappApi } from "./WhatsappApi";
import { ComissaoPorClassificacaoApi } from "./ComissaoPorClassificacaoApi";
import { OrcamentoWebSnapshotApi } from "./OrcamentoWebSnapshotApi";

import { MetasBonusApi } from "./MetasBonusApi"; // PA 474948
export class MicrouniversoApi {
    public readonly Produto: ProdutoApi
    public readonly Cliente: ClienteApi
    public readonly Orcamento: OrcamentoApi
    public readonly Parametro: ParametroApi
    public readonly PermissaoFuncionalidade: PermissaoFuncionalidadeApi
    public readonly TipoPesquisa: TipoPesquisaApi
    public readonly Seguranca: SegurancaApi
    public readonly Filial: FilialApi
    public readonly Vendedor: VendedorApi
    public readonly Comum: ComumApi
    public readonly Usuario: UsuarioApi
    public readonly Pessoa: PessoaApi;
    public readonly AtendimentoCliente: AtendimentoClienteApi;
    public readonly Fonecedor: FornecedorApi
    public readonly Frete: FreteApi
    public readonly AgenteDiaUtil: AgenteDiaUtilApi
    public readonly Obra: ObraApi;
    public readonly Login: LoginApi
    public readonly Licenciamento: LicenciamentoApi
    public readonly CupomDesconto: CupomDescontoApi
    public readonly CotacaoPerdida: CotacaoPerdidaApi
    public readonly UnificacaoDeOrcamentos: UnificacaoDeOrcamentosApi
    public readonly NotaFiscalSaida: NotaFiscalSaidaApi
    public readonly NotaFiscalEntrada: NotaFiscalEntradaApi
    public readonly ConhecimentoTransporte: ConhecimentoTransportelApi
    public readonly OrdemProducao: OrdemProducaoApi
    public readonly Desdobramento: DesdobramentoApi
    public readonly Whatsapp: WhatsappApi;
    public readonly ComissaoPorClassificacao: ComissaoPorClassificacaoApi; //482087
    public readonly OrcamentoWebSnapshot: OrcamentoWebSnapshotApi; 
    public readonly MetasBonus: MetasBonusApi; // PA 474948

    constructor() {
        this.Produto = new ProdutoApi()
        this.Cliente = new ClienteApi()
        this.Orcamento = new OrcamentoApi()
        this.Parametro = new ParametroApi()
        this.PermissaoFuncionalidade = new PermissaoFuncionalidadeApi()
        this.TipoPesquisa = new TipoPesquisaApi()
        this.Seguranca = new SegurancaApi()
        this.Filial = new FilialApi()
        this.Vendedor = new VendedorApi()
        this.Usuario = new UsuarioApi()
        this.Comum = new ComumApi()
        this.Pessoa = new PessoaApi()
        this.AtendimentoCliente = new AtendimentoClienteApi();
        this.UnificacaoDeOrcamentos = new UnificacaoDeOrcamentosApi();
        this.ComissaoPorClassificacao = new ComissaoPorClassificacaoApi() // 482087
        this.MetasBonus = new MetasBonusApi(); // PA 474948

        this.Fonecedor = new FornecedorApi()
        this.Frete = new FreteApi()
        this.AgenteDiaUtil = new AgenteDiaUtilApi()
        this.Obra = new ObraApi()
        this.Login = new LoginApi()
        this.Licenciamento = new LicenciamentoApi();
        this.CupomDesconto = new CupomDescontoApi()
        this.CotacaoPerdida = new CotacaoPerdidaApi()
        this.NotaFiscalSaida = new NotaFiscalSaidaApi();
        this.NotaFiscalEntrada = new NotaFiscalEntradaApi();
        this.ConhecimentoTransporte = new ConhecimentoTransportelApi();
        this.OrdemProducao = new OrdemProducaoApi();
        this.Desdobramento = new DesdobramentoApi();
        this.Whatsapp = new WhatsappApi();
        this.OrcamentoWebSnapshot = new OrcamentoWebSnapshotApi();
    }
}
